import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import { WarningMessage } from '../../../components/widgets';
import FormSection from '../FormSection';
import { TRANSLATE_PREFIX } from '../../consts';
import css from './PostbackTemplatesTab.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_TEMPLATES_TAB`;

const infoContent = (
    <div>
        <Translate id={`${TAB_PREFIX}.INFO_CONTENT_INTRO`} />
        <ul className={css.infoList}>
            <li>
                <strong>
                    <Translate id={`${TAB_PREFIX}.INFO_CONTENT_KEY_LABEL`} />
                </strong>{' '}
                <Translate id={`${TAB_PREFIX}.INFO_CONTENT_KEY_DESC`} />
            </li>
            <li>
                <strong>
                    <Translate id={`${TAB_PREFIX}.INFO_CONTENT_MACRO_LABEL`} />
                </strong>{' '}
                <Translate id={`${TAB_PREFIX}.INFO_CONTENT_MACRO_DESC`} />
            </li>
        </ul>
        <div>
            <strong>
                <Translate id={`${TAB_PREFIX}.INFO_CONTENT_RESULT_LABEL`} />
            </strong>{' '}
            <code>
                <Translate id={`${TAB_PREFIX}.INFO_CONTENT_RESULT_EXAMPLE`} />
            </code>
        </div>
    </div>
);

const PostbackTemplatesTab = () => (
    <FormSection
        titleKey={`${TRANSLATE_PREFIX}.TABS.POSTBACK_TEMPLATES`}
        descriptionKey={`${TAB_PREFIX}.DESCRIPTION`}
        iconName="template"
    >
        <WarningMessage
            type="info"
            showIcon={false}
            collapsible
            collapsibleTitle={`${TAB_PREFIX}.INFO_TITLE`}
            message={infoContent}
        />
    </FormSection>
);

export default withLocalize(PostbackTemplatesTab);
